<template>
    <div
        class="vx-flex vx-flex-col vx-gap-2"
        :class="{
            'vx-items-end': props.message.direction === 'outbound' || props.scheduled,
            'vx-items-start': props.message.direction === 'inbound',
        }"
    >
        <div v-if="props.unread" class="vx-relative vx-flex vx-items-center vx-justify-center vx-w-full vx-my-4">
            <div class="vx-absolute vx-border-0 vx-border-b vx-border-solid vx-border-amber-300 vx-w-full"></div>
            <vx-badge color="amber" borders size="xs" class="vx-absolute vx-text-center vx-px-3 vx-py-1">
                New
            </vx-badge>
        </div>
        <div
            class="vx-flex vx-flex-col vx-gap-2 vx-px-4"
            :class="{
                'vx-items-end': props.message.direction === 'outbound' || props.scheduled,
                'vx-items-start': props.message.direction === 'inbound',
            }"
        >
            <div class="vx-flex vx-justify-center vx-items-center vx-max-w-96">
                <span
                    class="vx-text-sm vx-text-slate-800 vx-px-4 vx-py-3 vx-border vx-border-solid"
                    :class="{
                        'vx-bg-sky-100 vx-border-sky-200 vx-rounded-l-lg vx-rounded-tr-lg vx-rounded-br-[0.25rem]':
                            props.message.direction === 'outbound' || props.scheduled,
                        'vx-bg-slate-100  vx-border-slate-200 vx-rounded-r-lg vx-rounded-tl-lg vx-rounded-[0.25rem]':
                            props.message.direction === 'inbound',
                    }"
                    >{{ props.message.body }}</span
                >

                <font-awesome-icon
                    v-if="props.scheduled"
                    :icon="faMessagePen"
                    size="xl"
                    class="vx-text-sky-500 vx-cursor-pointer vx-ml-2"
                    @click="emit('editSchedule')"
                >
                </font-awesome-icon>
            </div>
            <div
                v-if="props.message.media_url"
                class="vx-p-4 vx-border vx-border-solid"
                :class="{
                    'vx-bg-sky-100 vx-border-sky-200 vx-rounded-l-lg vx-rounded-tr-lg vx-rounded-br-[0.25rem]':
                        props.message.direction === 'outbound' || props.scheduled,
                    'vx-bg-slate-100  vx-border-slate-200 vx-rounded-r-lg vx-rounded-tl-lg vx-rounded-[0.25rem]':
                        props.message.direction === 'inbound',
                }"
            >
                <message-media
                    :media-url="props.message.media_url"
                    :media-content-type="props.message.media_content_type"
                    @mediaPlaceholderClick="emit('mediaPlaceholderClick', $event)"
                ></message-media>
            </div>
            <div
                class="w-full vx-flex vx-flex-col vx-text-xs"
                :class="{
                    'vx-items-end': props.message.direction === 'outbound' || props.scheduled,
                    'vx-items-start': props.message.direction === 'inbound',
                }"
            >
                <template v-if="props.scheduled">
                    <span v-if="message.user" class="vx-text-slate-500 vx-inline-flex vx-items-center">
                        <span>User</span>
                        <span class="vx-mx-1">&rarr;</span>
                        <span>{{ message.user ? ` ${message.user?.name}` : '' }} </span>
                    </span>
                    <span class="vx-text-slate-800"
                        >Scheduled for
                        {{ dayjs(message.created_at).tz(getClientTz()).format('MMM Do, YYYY h:mm a z') }}</span
                    >
                </template>
                <template v-else>
                    <span
                        v-if="props.message.direction === 'outbound'"
                        class="vx-text-slate-500 vx-inline-flex vx-items-center"
                    >
                        <span>{{ props.message?.origin_meta?.type || 'Outbound' }}</span>
                        <span class="vx-mx-1">&rarr;</span>
                        <span>{{ props.message?.origin_meta?.description || 'Ghost' }}</span>
                    </span>
                    <span class="vx-text-slate-800">{{
                        dayjs(props.message.created_at).tz(getClientTz()).format('MMM Do, YYYY h:mm a z')
                    }}</span>
                </template>
            </div>
        </div>
    </div>
</template>
<script setup>
import { VxBadge } from '@voxie/frontend-components';
import MessageMedia from './MessageMedia.vue';
import { getClientTz } from '~/utils/date';
import dayjs from '~/utils/dayjs';
import { faMessagePen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const props = defineProps({
    message: {
        type: Object,
        required: false,
    },
    unread: {
        type: Boolean,
        default: false,
    },
    scheduled: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['editSchedule', 'mediaPlaceholderClick']);
</script>
